// Home and realisations archive: the Particuliers / Professionnels switch and the category chips filter the grid in place
// home: one segment for the whole page, driven by the expertises tabs: the hero doors and the realisations switch
// show the matching tab instead of opening the segment page (the doors also scroll to the expertises), the realisations follow the active tab
// archive (no expertises tabs): the switch sets the segment directly
const section = document.querySelector('.home-realisations')
const grid = section?.querySelector('.home-realisations-grid')
const TABS = {
  particuliers: '#expertises_panel_p',
  professionnels: '#expertises_panel_b'
}

if (grid) {
  const chips = section.querySelectorAll('.home-filter-chip, .home-filter-universe a')
  const allChip = section.querySelector('.home-filter-chip')
  const segments = section.querySelectorAll('[data-gp-segment]')
  const tabs = Object.fromEntries(Object.entries(TABS).map(([name, target]) => [name, document.querySelector(`[data-bs-target="${target}"]`)]))
  // no switch (realisation page, "other realisations"): no segment filter
  let segment = null
  if (segments.length) {
    segment = tabs.professionnels?.classList.contains('active') ? 'professionnels' : 'particuliers'
  }
  let category = null

  const update = () => {
    segments.forEach((item) => {
      item.classList.toggle('active', item.dataset.gpSegment === segment)
      item.setAttribute('aria-pressed', String(item.dataset.gpSegment === segment))
    })
    grid.classList.toggle('is-filtered', Boolean(category))
    grid.querySelectorAll(':scope > li').forEach((item) => {
      const categories = item.dataset.gpCategories?.split(' ') ?? []
      item.hidden = Boolean(segment) && !categories.includes(segment) || Boolean(category) && !categories.includes(category)
    })
  }

  const showSegment = (event, name) => {
    // ctrl/cmd/shift click: keep the link (new tab)
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      return
    }
    event.preventDefault()
    if (tabs[name]) {
      tabs[name].click()
    } else {
      segment = name
      update()
    }
  }

  Object.entries(tabs).forEach(([name, tab]) => {
    tab?.addEventListener('shown.bs.tab', () => {
      segment = name
      update()
    })
  })

  segments.forEach((item) => item.addEventListener('click', (event) => showSegment(event, item.dataset.gpSegment)))

  // hero doors: show the segment, then scroll down to the expertises
  const expertises = document.querySelector('.home-expertises')
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  document.querySelectorAll('.home-door a').forEach((link) => {
    const name = link.closest('.home-door-secondary') ? 'professionnels' : 'particuliers'
    link.addEventListener('click', (event) => {
      showSegment(event, name)
      if (event.defaultPrevented) {
        expertises.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth'
        })
      }
    })
  })

  chips.forEach((chip) => chip.setAttribute('aria-pressed', String(chip === allChip)))

  chips.forEach((chip) => {
    chip.addEventListener('click', (event) => {
      event.preventDefault()

      // "Tout" has no data-gp-filter: back to all the realisations of the segment (the 7 latest on the home, CSS)
      category = chip.closest('[data-gp-filter]')?.dataset.gpFilter ?? null

      chips.forEach((item) => item.setAttribute('aria-pressed', String(item === chip)))
      update()
    })
  })

  update()
}
